
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.5","cy":"12.619","r":"11","stroke":"#56BFC7","stroke-width":"2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.611 11.218a1.424 1.424 0 00-2.013-2.013l-3.704 3.703-1.064-1.064a1.576 1.576 0 10-2.229 2.229l2.014 2.014a1.576 1.576 0 002.525-.41c.041-.033.082-.07.12-.108l4.351-4.35z","fill":"#56BFC7"}})])
          )
        }
      }
    